import { Checkbox, ListItemText } from "@material-ui/core";
import { useGetModelBundleTagsQuery } from "../../../../generated/graphql";
import { FilterSelect, FilterMenuItem } from "../../styles";

interface TagsFilterProps {
  label: string;
  selectedValues: string[];
  onChange: (values: string[]) => void;
}

export const TagsFilter = ({ label, selectedValues, onChange }: TagsFilterProps) => {
  const { data } = useGetModelBundleTagsQuery();
  const tags = data?.getModelBundleTags || [];
  const allTagIds = tags.map(({ id }) => id);

  return (
    <FilterSelect
      multiple
      displayEmpty
      variant="outlined"
      value={selectedValues.length === 0 ? allTagIds : selectedValues}
      renderValue={() => label}
      onClick={(e) => e.stopPropagation()}
      onChange={(e) => {
        const values = e.target.value as string[];
        onChange(values.length === allTagIds.length ? [] : values);
      }}
    >
      {tags.map(({ id, name }) => (
        <FilterMenuItem key={id} value={id}>
          <Checkbox checked={selectedValues.length === 0 || selectedValues.includes(id)} />
          <ListItemText primary={name} />
        </FilterMenuItem>
      ))}
    </FilterSelect>
  );
};
